import * as REST from '../api/rest';
import {
  createServiceRequested,
  createServiceSuccess,
  createServiceFailure,
  createEcosystemRoleRequested,
  createEcosystemRoleSuccess,
  createEcosystemRoleFailure,
} from './ecosystems/actions';
import { createPolicyObject } from './objects/actions';

export function createService(service) {
  return async (dispatch, getState) => {
    try {
      dispatch(createServiceRequested());
      const result = await REST.createService({
        customer: getState().customers.currentCustomer,
        ecosystem: getState().ecosystems.currentEcosystem,
        service,
      });
      dispatch(createServiceSuccess(result));
    } catch (error) {
      dispatch(createServiceFailure(error));
    }
  };
}

export function createRole({ roleName, field }) {
  return async (dispatch, getState) => {
    try {
      dispatch(createEcosystemRoleRequested());
      const result = await REST.createRole({
        customer: getState().customers.currentCustomer,
        ecosystem: getState().ecosystems.currentEcosystem,
        name: roleName,
      });
      dispatch(createEcosystemRoleSuccess(result));
      if (field) {
        dispatch(
          createPolicyObject({
            object: { ...result, element: 'role', type: 'role' },
            field,
          }),
        );
      }
    } catch (error) {
      dispatch(createEcosystemRoleFailure(error));
    }
  };
}
